import styled from '@emotion/styled';

import { Glyph } from '../common/Glyph';
import { Heading2Medium } from '../common/text/Heading2Medium';
import { TextRegular } from '../common/text/TextRegular';

import { su } from '../../theme/functions/su';
import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';

export function ControlsMessage(props) {
  const url =
    props.type === 'warning' ? glyph.core.exclamationmarkTriangleFill : glyph.core.checkmarkCircle;

  return (
    <ControlsErrorContainer>
      <Glyph source={url} size="52px" />
      <ControlsTitle color={theme.color.text_white} textAlign="center" lineHeight="26px">
        {props.title}
      </ControlsTitle>
      <ControlsMessageText color={theme.color.text_light} textAlign="center" lineHeight="18px">
        {props.message}
      </ControlsMessageText>
    </ControlsErrorContainer>
  );
}

const ControlsErrorContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${su(6)};
`;

const ControlsTitle = styled(Heading2Medium)`
  margin-top: 14px;
`;

const ControlsMessageText = styled(TextRegular)`
  margin-top: 4px;
`;
